import React from 'react';
const  TableBlock = (props) => {
  return(	
  <>	
  	{/*  <!-- SECTION CONTENT START --> */}
	<div className="section-full p-t80 p-b50">
		<div className="container">
			{/* <!-- TABLE RESPONSIVE --> */}
			<div className="section-content m-b80">
				<div className="p-b30">
					<h3 className="text-uppercase">Admission Eligibility</h3>
					<div className="wt-separator-outer">
						<div className="wt-separator style-icon">
							<i className="fa fa-leaf text-black"></i>
							<span className="separator-left site-bg-primary"></span>
							<span className="separator-right site-bg-primary"></span>
						</div>
					</div>
					<p>At Our School, we are committed to nurturing young minds and fostering a vibrant community where every child feels valued and inspired to grow. Our admission process is designed to identify students who are ready to embark on an enriching academic journey with us.</p>
					<h4>Age Requirements:</h4>
				</div>

				<div id="no-more-tables">
					<table className="col-md-12 table-bordered table-striped table-condensed cf wt-responsive-table">
						<thead className="cf">
							<tr>
								<th>Class</th>
								<th>Age Criteria</th>								
							</tr>
						</thead>
						<tbody>
							<tr>
								<td data-title="Pre-School">Pre-School</td>
								<td data-title="Age Criteria">Less than 04 years as on 31st March 2025</td>
								
								
								
							</tr>
							<tr>
								<td data-title="Pre-PRIMARY">Pre-PRIMARY</td>
								<td data-title="Age Criteria">Less than 05 years as on 31st March 2025</td>
								
								
							</tr>
							<tr>
								<td data-title="Class-1">Class-1</td>
								<td data-title="Age Criteria">Less than 06 years as on 31st March 2025</td>
								
								
							</tr>
							
								
						</tbody>
					</table>
				</div>
			</div>
			
			
		</div>
	</div>
	{/* <!-- SECTION CONTENT END --> */}	
  </>
  )
}
 export default TableBlock;